import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CForm, CFormInput, CInputGroup, CInputGroupText, CFormSelect, CButton,
	CImage,
	CCard, CCardHeader, CCardBody, CCardFooter,
	CSpinner,
	CLink,
	CDropdown,CDropdownItem,CDropdownToggle,CDropdownMenu,
	CTooltip,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import {
	MyDialogform,
	MyPagination,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import {
	UFunc,cAngkaTgl,cBulanPendek,cBulanPanjang 
} from '../helpers/functions'

const pjson 	= require('../../package.json')
const Lapomzet 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 				= useNavigate();
	const uDispatch 				= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uSettingsistemObj			= useSelector(state => state.gSystemsetting);
	const uEfekapp					= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 10) : (uSettingObj.jml_laporan || 100);
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uSystemsettingObj			= useSelector(state => state.gSystemsetting);
	const uSelisihrangetanggal 		= useSelector(state => state.gSelisihrangetanggal);
	
	const uHeaderActionObj  		= useSelector(state => state.gInitHeaderAction);
	const uHandelView 				= uHeaderActionObj.isHeaderView || false;
	const uHandelReset 				= uHeaderActionObj.isHeaderreset || false;

	//--VIEWS_VARS--/
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const uIsHapusallow					= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN") ? true : false;
	const [uIsDataloaded,setDataloaded]	= React.useState(false); 
	const [uCaptionObj,setCaptionObj]	= React.useState({}); 
	const [uFilterObj,setFilterObj]		= React.useState({});
	const [uFirstload,setFirstload]		= React.useState("YA");
	const [uSortedObj,setSortedObj]		= React.useState({});
	//const uFilterObj		  		= useSelector(state => state.gFilterObj) || {};

	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uRowselect,setRowselect]		= React.useState(-1);
	const [uIDselect,setIDselect]		= React.useState(0);

	const uDatacabangArr					= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const [uDatadefaultArr,setDatadefaultArr]= React.useState([]);
	const [uDatamainArr,setDatamainArr]		= React.useState([]);
	const [uDatasumArr,setDatasumObj]		= React.useState({});
	const [uDataasuransiArr,setDataasuransiArr]= React.useState([]); 
	const [uDatapaymentArr,setDatapaymentArr]= React.useState([]); 
	const [uEfekview2,setEfekview2] 		= React.useState(false);
	//--END VIEWS_VARS--*/

	//--FORM_VARS--/
	const [uIsDlgformshow,setDlgformshow]	= React.useState(false);
	const [uHeaderDlgform,setHeaderDlgform]	= React.useState("");
	const [uFormdataObj,setFormdataObj]		= React.useState({});
	//--END FORM_VARS--/

	//--DOM_VARS--/
	const uElJmlData					= document.getElementById("idjmldata");
	const [uElBtnsimpan,setElBtnsimpan]	= React.useState(document.getElementById("btnDialogSimpan"));
	const fileType 				= "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	const fileExtension 		= ".xlsx";
	//--END DOM_VARS--/

	//--SETTING_CETAK--/
	const uSettingcetakObj		= JSON.parse(localStorage.getItem("settingnota")) || {};
	const uHTMLstylelaporan		= useSelector(state => state.gHTMLstyleLaporan);
	const uHTMLstylenota		= useSelector(state => state.gHTMLstyleNota);
	const uLebarKertas			= parseInt(uSettingcetakObj.lebarkertas)||0;
	const uMarginKiri			= parseInt(uSettingcetakObj.marginkiri)||1;
	const uFontsize				= parseInt(uSettingcetakObj.fontsize)||12;
	const uViewLogo				= uSettingcetakObj.view_image_nota ||"TIDAK";
	const uFontstyle			= uSettingcetakObj.fontstyle || "Courier, Courier New, Sans Serif";
	const uFrameExport 			= document.getElementById("ifmcontentstoprint");
	//--END SETTING_CETAK--/

	//--HANDEL--/
	const hdlToggleDlgform = () => { setDlgformshow(false) }
	const hdlKlikDlgsimpan = () => {
		//--VALIDASI_FILTER--/
		let vElfocus	= document.getElementById("inpcabangid");
		if(parseInt(uFormdataObj.cabang_id||"0") <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Cabang Harus Dipilih !");
			return
		}

		vElfocus		= document.getElementById("inptglawal");
		let vTanggal  	= uFormdataObj.tgl_awal;
		if(!UFunc.isDateValid(vTanggal)) {
			vElfocus && vElfocus.focus();
			showToast("Tanggal Awal Laporan Tidak Valid !"); return
		}
		const vTglawalDT	= UFunc.toDate(vTanggal);

		vElfocus	= document.getElementById("inptglakhir");
		vTanggal  	= uFormdataObj.tgl_akhir;
		if(!UFunc.isDateValid(vTanggal)) {
			vElfocus && vElfocus.focus();
			showToast("Tanggal Akhir Laporan Tidak Valid !"); return
		}
		const vTglakhirDT	= UFunc.toDate(vTanggal);

		if(vTglawalDT.valueOf() > vTglakhirDT.valueOf()) {
			vElfocus && vElfocus.focus();
			showToast("Tgl Awal Melewati Tgl Akhir ! "); return
		}

		if(UFunc.DateIsBeyond(vTglawalDT) && UFunc.DateIsBeyond(vTglakhirDT)) {
			vElfocus && vElfocus.focus();
			showToast("Periode Laporan Melewati Tanggal SAAT INI ! "); return
		}

		if(UFunc.SelisihHari(UFunc.DbDate(vTglawalDT),UFunc.DbDate(vTglakhirDT)) > uSelisihrangetanggal) {
			vElfocus && vElfocus.focus();
			showToast("Maksimal Selisih Range Tanggal adalah "+uSelisihrangetanggal+" hari.."+
				"<br/>Mohon Diperbaiki !"+
				""); return
		}
		//--END VALIDASI_FILTER--/

		setDataloaded(false);
		apiLoaddata();
	}
	const hdlKlikSort = (_NAMAKOL) => {
		_NAMAKOL		= (_NAMAKOL||"").toUpperCase();
		const vNamenow	= (uSortedObj.nama||"").toUpperCase();
		const vSortnow	= (uSortedObj.jenis||"").toUpperCase();

		const vSortedObj		= uSortedObj;
		vSortedObj.init_aktif 	= "YA";
		if(vNamenow==="" || vNamenow !== _NAMAKOL) {
			vSortedObj.nama 	= _NAMAKOL.toLowerCase();
			vSortedObj.jenis 	= "ASCENDING";
		} else if(vNamenow===_NAMAKOL) {
			if(vSortnow==="ASCENDING")
				vSortedObj.jenis = "DESCENDING";
			else if(vSortnow==="DESCENDING") {
				 vSortedObj.nama 	= "";
				 vSortedObj.jenis 	= "";
			}
		}
		vSortedObj.init_aktif 	= undefined;

		setSortedObj(vSortedObj);
		setEfekview(!uEfekview);
	}
	const hdlKlikCetak = () => {
		if(uDatamainArr.length <= 0) return;

		const vContent 	= contentCetaklaporan();
		if(vContent === "") return
		//console.log("(Lapomzet - hdlKlikCetak) vContent = "+vContent)

		var pri 		= uFrameExport.contentWindow;
		pri.document.open();
		pri.document.write(vContent);
		pri.document.close();
		pri.window.focus();
		pri.window.print();
	}
	const hdlKlikExcel = () => {
		if(uJmlData <= 0) return;

		contentExcel();
	}
	//--END HANDEL--/

	//--INIT--/
	const initResettampilan = () => {
		setCaptionObj({}); setDatamainArr([]);// setJmlData(0);
		setFilterObj({}); setSortedObj({});
	}
	const initJmldata = () => {
		uElJmlData 
			&& (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	}
	//--END INIT--/

	//--CONTENT--/
	const contentDlgform = () => {
		if(!uIsDlgformshow) return (<></>)//>

		const vCabangID 		= uFormdataObj.cabang_id || 0;
		const vCabangviewArr	= uTokenObj.userhak==="FREEROLE" ? uDatacabangArr
			: uDatacabangArr.filter(vItems=>(uTokenObj.user_cabangarr || []).includes(vItems.id.toString()))

		return (
		<CForm>
		{uDatacabangArr.length > 1 && (
		<CRow className="my-2">
			<CCol xs="7">Cabang</CCol>
			<CCol className="text-end">
			<CFormSelect size="sm"
				value={uFormdataObj.cabang_id||0}
				onChange={(e)=>{uFormdataObj.cabang_id = e.target.value; setEfekview(!uEfekview)}}
				id="inpcabangid">
				{vCabangviewArr.map((vItems,vKeys)=>{
					const {
						id,cabang_nama
					} = vItems

					return (
					<option value={id} key={vKeys}>{(cabang_nama||"UNDF").toUpperCase()}</option>
					)
				})}
			</CFormSelect>
			</CCol>
		</CRow>
		)}

		<CRow className="my-2">
		<CCol xs="3" md="4">Tanggal</CCol>
		<CCol className="text-end">
			<CInputGroup size="sm">
			<CFormInput size="sm" type="date"
				value={uFormdataObj.tgl_awal}
				onChange={(e)=>setFormdataObj({...uFormdataObj,tgl_awal: e.target.value})}
				id="inptglawal"/>
			<CInputGroupText>s.d.</CInputGroupText>
			<CFormInput size="sm" type="date"
				value={uFormdataObj.tgl_akhir}
				onChange={(e)=>setFormdataObj({...uFormdataObj,tgl_akhir: e.target.value})}
				id="inptglakhir"/>
			</CInputGroup>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="3" md="4">Metode Payment</CCol>
		<CCol className="text-end">
			<CFormSelect size="sm" className="py-1"
				value={uFormdataObj.payment_id ?? "-1"}
				onChange={(e)=>setFormdataObj({...uFormdataObj,payment_id: e.target.value})}
				id="inppaymentid">
				<option value="-1">&middot;&middot; SEMUA PAYMENT &middot;&middot;</option>
				<option value="0">T U N A I</option>
				{uDatapaymentArr.map((vItems,vKeys)=>{
					return (
					<option value={vItems.id} key={vKeys}>{(vItems.nama_payment||"").toUpperCase()}</option>
					)//>
				})}
			</CFormSelect>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="3" md="4">Asuransi</CCol>
		<CCol className="text-end">
			<CFormSelect size="sm" className="py-1"
				value={uFormdataObj.asuransi_id ?? "0"}
				onChange={(e)=>setFormdataObj({...uFormdataObj,asuransi_id: e.target.value})}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
				id="inpasuransiid">
				<option value="0">&middot;&middot; SEMUA ASURANSI &middot;&middot;</option>
				{uDataasuransiArr.map((vItems,vKeys)=>{
					return (
					<option value={vItems.id} key={vKeys}>{(vItems.nama_asuransi||"").toUpperCase()}</option>
					)//>
				})}
			</CFormSelect>
		</CCol>
		</CRow>
		</CForm>
		)//>
	}
	const contentLaporan = () => {
		if(!uIsDataloaded) return (<></>)//>

		if(uJmlData <= 0) return (
			<div className="mx-md-5 p-3 p-md-5">
			&middot;&middot; {uBahasaObj.caption_dataempty||"Data Tidak Ada"} &middot;&middot;
			</div>
		)//>

		const vMin			= (uPageActive-1) * uMaxData;
		const vMax			= (vMin + uMaxData);
		let vNumber			= (vMin);

		const vDataviewArr	= uDatamainArr.slice(vMin,vMax);
		const vISpaymentselected	= parseInt(uFilterObj.payment_id ?? "-1") >= 0;


		const vStylekolfixed = {
			position: "sticky",
			left: 0,
			background: "#f0f0f0",
			zIndex: 1,
			borderRight:"1px solid #DCDCDC",
		}
		const vWidthtabel = 1150;

		return (
		<div style={{overflowX:"auto"}} className="" id="iddivtabel">
		<table 
			style={{minWidth:vWidthtabel,width:"100%"}}
			className="table table-borderless table-striped table-hover" 
			id="idtabeldata">
		<thead>
			<tr className="text-start align-top classfontsmaller">
			<th width={45} className="px-1 text-center border" style={vStylekolfixed}><small>No</small></th>
						
			<th width={110} className="px-1 border" style={{...vStylekolfixed,left:45}}><small>{uBahasaObj.caption_tglbayar||"Tgl Bayar"}</small></th>
			<th width={110} className="px-1 border"><small>{uBahasaObj.word_nonota||"No.Nota"}</small></th>
			<th width={270} className="px-1 border"><small>{uBahasaObj.word_pasien||"Pasien"}</small></th>

			<th className="px-1 border"><small>{uBahasaObj.word_keterangan||"Keterangan"}</small></th>

			<th width={125} className="px-1 border">
				<small>
				<div className="d-flex justify-content-between align-items-center">
				<div style={{width:"calc(100% - 25px)"}} className={"text-center"+((uSortedObj.nama||"")==="nilai_omzet" ? " text-danger" : "")}>
				{uBahasaObj.caption_ntagihan||"N.Tagihan"}<br/>(Rp)
				</div>

				<CLink className="classcursorpointer text-black"
					onClick={()=>hdlKlikSort("nilai_tagihan")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_tagihan" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={20}/>
				</CLink>
				</div>
				</small>
			</th>

			<th width={110} className="px-1 text-center border">
				<small>
				<div className="d-flex justify-content-between align-items-center">
				<div style={{width:"calc(100% - 25px)"}} className={"text-center"+((uSortedObj.nama||"")==="nilai_jumlah" ? " text-danger" : "")}>
				N.Terbayar<br/>(Rp)
				</div>

				<CLink className="classcursorpointer text-black"
					onClick={()=>hdlKlikSort("nilai_terbayar")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_terbayar" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={20}/>
				</CLink>
				</div>
				</small>
			</th>

			<th width={110} className="px-1 border">
				<small>
				<div className="d-flex justify-content-between align-items-center">
				<div style={{width:"calc(100% - 25px)"}} className={"text-center"+((uSortedObj.nama||"")==="nilai_sisa" ? " text-danger" : "")}>
				{uBahasaObj.caption_nsisa||"N.Sisa"}<br/>(Rp)
				</div>

				<CLink className="classcursorpointer text-black"
					onClick={()=>hdlKlikSort("nilai_sisa")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_sisa" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={20}/>
				</CLink>
				</div>
				</small>
			</th>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys)=>{
			const {
				id,pasien_caption,pasien_telp,no_nota,dokter_caption,
				tgl_bayar,nilai_diskon,nilai_omzet,nilai_bayar_before,nilai_tagihan,
				nilai_terbayar,nilai_sisa,
				items_arr,asuransi_caption,nilai_asuransi,asuransi_id,
				init_processing,payment_arr,
			} = vItems;

			vNumber++;
			const vPaymentArr	= !vISpaymentselected 
				? (payment_arr || []) : (payment_arr || []).
					filter(vItems=>vItems.init_asuransi==="YA");


			return (
			<tr id={"idtr"+id} className={"align-top "+(uRowselect===vKeys?"classrowselect":"")}
				 key={vKeys}>
			<td className="px-1 text-end" style={vStylekolfixed}>{(vNumber)}.</td>

			<td  className="text-start" style={{...vStylekolfixed,left:45}}>{UFunc.TglAngka(tgl_bayar)}</td>

			<td className="text-start px-1"><small>{no_nota||"UNDFNOTA"}</small></td>

			<td className="text-start px-1">
				<div className="text-capitalize text-info">{pasien_caption||"UNDF"}</div>
				<div className="fst-italic"><small>{dokter_caption||"UNDF"}</small></div>
			</td>

			<td className="text-start px-1 classfontsmaller">
				<div className="fw-bolder">Item Terapi</div>
				<small>
				<ul className="ps-3">
				{(items_arr||[]).map((vItemterapi,vKeyterapi)=>{
					return (
					<li key={vKeyterapi} className="">
						<div className='d-flex justify-content-between'>
						{(parseFloat(vItemterapi.diskon_terapi)||0) > 0 ? (
						<span className="fst-italic" style={{maxWidth:"50%"}}>{vItemterapi.caption_terapi}</span>
						) : (
						<span className="fst-italic" style={{maxWidth:"70%"}}>{vItemterapi.caption_terapi}</span>
						)}

						<div className="text-end">
							<b>{UFunc.formatAngka(vItemterapi.qty)}</b> Unt
							<span> x </span>

							{(parseFloat(vItemterapi.diskon_terapi)||0) > 0 ? (
							<>
								<span>(</span>
								<b>{UFunc.formatAngka(vItemterapi.harga_terapi)}</b>
								<span>-</span>
								<span className="text-danger">{UFunc.formatAngka(vItemterapi.diskon_terapi)}</span>
								<span>)</span>
							</>
							) : (
								<b>{UFunc.formatAngka(vItemterapi.harga_terapi)}</b>
							)}
						</div>
						</div>
					</li>
					)//>
				})}
				</ul>
				</small>

				{parseFloat(nilai_diskon ?? 0) > 0 && (
				<>
					<div className="my-1 classborderbottom"/>
					<div className="d-flex justify-content-between align-items-start">
						<span className="fw-bolder">Diskon Transaksi</span>
						<span className="text-danger"><b>{UFunc.formatAngka(nilai_diskon)}</b></span>
					</div>
				</>
				)}
					
				<div className="my-1 classborderbottom"/>
				<div className="d-flex justify-content-between align-items-start">
					<span className="fw-bolder">N.Transaksi</span>
					<span><b>{UFunc.formatAngka(nilai_omzet)}</b></span>
				</div>

				{parseFloat(nilai_bayar_before ?? 0) > 0 && (
				<>
					<div className="my-1 classborderbottom"/>
					<div className="d-flex justify-content-between align-items-start">
						<span className="fw-bolder">Terbayar Sebelumnya</span>
						<span className="text-primary"><b>{UFunc.formatAngka(nilai_bayar_before)}</b></span>
					</div>
				</>
				)}

				{(vPaymentArr.length > 0) && (
				<>
				<div className="my-1 classborderbottom"/>
				<div className="fw-bolder">Metode Pembayaran</div>
				<ul className="ps-3">
					{vPaymentArr.map((vItempayment,vKeypayment)=>{
						const vInitasuransi = vItempayment.init_asuransi || "TIDAK";

						return (
						<li key={vKeypayment}>
						<div className='d-flex justify-content-between'>
							<span className="fst-italic" style={{maxWidth:"70%",color:vInitasuransi==="YA"?"purple":"initial"}}>{vItempayment.payment_caption}</span>
							
							{(payment_arr||[]).length > 1 && (
							<div className="text-end">
								<b>{UFunc.formatAngka(vItempayment.payment_bayar)}</b>
							</div>
							)}
						</div>
						</li>
						);
					})}
				</ul>
				</>
				)}
			</td>

			<td className="px-1 text-end">{UFunc.formatAngka(nilai_tagihan)}</td>

			<td className="px-1 text-end text-success">{UFunc.formatAngka(nilai_terbayar)}</td>
			
			<td className="px-1 text-end text-primary">{UFunc.formatAngka(nilai_sisa)}</td>
			</tr>
			)
		})}
		</tbody>

		<tfoot className="fw-bolder bg-primary text-white">
		<tr>
		<td style={vStylekolfixed} colSpan={2} className="px-1 text-center border text-uppercase d-lg-none bg-primary">
			{uBahasaObj.word_jumlah||"JUMLAH"} 
		</td>
		<td colSpan={3} className="px-1 text-center text-uppercase d-lg-none">&nbsp;</td>

		<td className="px-1 text-center text-uppercase d-none d-lg-table-cell" colSpan={5}>
			{uBahasaObj.word_jumlah||"JUMLAH"} 
		</td>

		<td className="px-1 text-end">
			{UFunc.formatAngka(uDatasumArr.nilai_tagihan)}
		</td>

		<td className="px-1 text-end">
			{UFunc.formatAngka(uDatasumArr.nilai_terbayar)}
		</td>

		<td className="px-1 text-end">
			{UFunc.formatAngka(uDatasumArr.nilai_sisa)}
		</td>
		</tr>
		</tfoot>

		</table>
		</div>
		)//>
	}
	const contentCetaklaporan = () => {
		if(uDatamainArr.length <= 0) return "";
		//console.log("(Lapomzet - contentCetaklaporan) vHTMLs => "+vHTMLs)

		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= (uDatacabangArr[vCabangIdx] || {}).cabang_nama || "UNDF";
		const vAsuransicaption = uFilterObj.asuransi_caption || "";

		const vPaymentidx 	= UFunc.getObjectIndeks(uDatapaymentArr,uFilterObj.payment_id);
		const vPaymentcaption= (uDatapaymentArr[vPaymentidx]||{}).nama_payment || "TUNAI";

		let vColspan = 7;

		let vHTMLs 	= uHTMLstylelaporan;
		vHTMLs += `
			<table id="idtabelhtml">
			<thead>
			<tr>
			<td colspan="`+vColspan+`">
			<div><b>`+(uBahasaObj["menus_"+uActiveroute.toLowerCase()]||"Laporan").toUpperCase()+`</b></div>
			<div>`+uCaptionObj.title+`</div>`+
			(uDatacabangArr.length > 1 ? `<div>Cabang: `+vCabangtext+`</div>` : ``)+`
			`+(parseInt(uFilterObj.payment_id ?? "-1") >= 0 
				? "<div>Payment: <b>"+vPaymentcaption+"</b></div>":"")+`
			`+(parseInt(uFilterObj.asuransi_id ?? "0") > 0 
				? "<div>Asuransi: <b>"+uFilterObj.asuransi_caption+"</b></div>":"")+`
			</td>
			</tr>
			<tr class="idtabelheader">
				<th width="5%"><small>No</small></th>
				<th width="11%" align="left"><small>`+(uBahasaObj.word_tanggal||"Tanggal")+`</small></th>
				<th width="12%" align="left"><small>`+(uBahasaObj.word_nonota||"No.Nota")+`</small></th>
				<th align="left"><small>`+(uBahasaObj.caption_namapasien||"Nama Pasien")+`</small></th>
				<th width="13%"><small>`+(uBahasaObj.caption_ntagihan || "N.Tagihan")+`<br/>(Rp)</small></th>
				<th width="11%"><small>`+(uBahasaObj.caption_nbayar || "N.Bayar")+`<br/>(Rp)</small></th>
				<th width="11%"><small>`+(uBahasaObj.caption_nsisa || "N.Sisa")+`<br/>(Rp)</small></th>
			</tr>
			</thead>
			<tbody>
		`;
		vHTMLs += uDatamainArr.map((vItems,vKeys)=>{
			const {
				id,kasir_caption,pasien_caption,no_nota,dokter_caption,
				nilai_asuransi,nilai_terbayar,nilai_omzet,tgl_transaksi,
				tgl_kasir,nilai_sisa,nilai_tagihan,
			} = vItems;

			return (`
				<tr key={vKeys} valign="top">
					<td align="right" style="font-size:smaller">`+(vKeys+1)+`.</td>

					<td align="left">
						<small>`+UFunc.TglAngka(tgl_transaksi)+`</small>
					</td>
					<td align="left">
						<small>`+(no_nota || "UNDFNOTA")+`</small>
					</td>
					
					<td align="left">`+
						pasien_caption+`
						<div><small>`+(dokter_caption||"Undf Dokter")+`</small></div>
					</td>

					<td align="right">`+UFunc.formatAngka(nilai_tagihan)+`</td>
					<td align="right">`+UFunc.formatAngka(nilai_terbayar)+`</td>
					<td align="right">`+UFunc.formatAngka(nilai_sisa)+`</td>
				</tr>
			`);
		}).join(``);

		vHTMLs += `
			</tbody>
			<tfoot>
			<tr>
			<td colspan="4" align="center">JUMLAH</td>
			<td align="right">`+UFunc.formatAngka(uDatasumArr.nilai_tagihan)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumArr.nilai_terbayar)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumArr.nilai_sisa)+`</td>
			</tr>
			</tfoot>
			</table>
		`;
		return vHTMLs		
	}
	const contentExcel = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";

		const vAsuransiIdx	= UFunc.getObjectIndeks(uDataasuransiArr,uFilterObj.asuransi_id);
		const vAsuransicaption= (uDataasuransiArr[vAsuransiIdx]||{}).nama_asuransi || "";

		const vPaymentidx 	= UFunc.getObjectIndeks(uDatapaymentArr,uFilterObj.payment_id);
		const vPaymentcaption= (uDatapaymentArr[vPaymentidx]||{}).nama_payment || "TUNAI";

		const vTanggalawalDT= UFunc.toDate(uFilterObj.tgl_awal);
		const vTanggalakhirDT= UFunc.toDate(uFilterObj.tgl_akhir);

		const vTglawallabel = vTanggalawalDT.getFullYear()+UFunc.leadZero(vTanggalawalDT.getMonth()+1)+UFunc.leadZero(vTanggalawalDT.getDate());
		const vTglakhirlabel= vTanggalakhirDT.getFullYear()+UFunc.leadZero(vTanggalakhirDT.getMonth()+1)+UFunc.leadZero(vTanggalakhirDT.getDate());

		const vISadadiskon	= uDatamainArr.filter(vItems => 
			parseFloat(vItems.nilai_diskon ?? "0") > 0).length > 0;

		const vISpaymentselected	= parseInt(uFilterObj.payment_id ?? "-1") >= 0;

		let vColspan		= 17;
		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			tgl_bayar: "",
			no_nota: "",
			dokter_caption: "",
			pasien_caption: "",
			item_caption: "",
			item_qty: "",
			item_harga: "",
			item_diskon: "",
			item_nilai: "",
			nilai_diskon: "",
			nilai_omzet: "",
			nilai_bayar_before: "",
			nilai_tagihan: "",
			nilai_terbayar: "",
			nilai_sisa: "",
			keterangan: "",
		}
		if(!vISadadiskon) {
			delete vTmpObj.nilai_diskon;
			vColspan--;
		}
		vDatasetsArr.push(vTmpObj);

		vRowcount++;
		let vItemcount;
		let vPaymentcount;
		let vPaymentISasuransi;
		let vPaymentnama 	= "";
		let vPaymentnilai 	= "";
		uDatamainArr.forEach((vItems,vKeys)=>{
			const {
				id,kasir_caption,pasien_caption,no_nota,dokter_caption,
				payment_arr,items_arr,nilai_terbayar,nilai_tagihan,
				tgl_bayar,nilai_omzet,nilai_diskon,nilai_sisa,nilai_bayar_before,
				asuransi_id,nilai_asuransi,
			} = vItems;

			vItemcount		= 0;
			vPaymentcount 	= 0;
			
			let vKeteranganArr	= (payment_arr || []);
			const vISRowadaasuransi = parseInt(asuransi_id ?? "0") > 0;
			
			vRowcount++;
			vColposwidth = (pasien_caption||"").length > vColposwidth 
				? (pasien_caption||"").length : vColposwidth; 

			const vItemcaption	= ((items_arr||[])[0]||{}).caption_terapi || "Undf Terapi";
			const vItemqty		= parseInt(((items_arr||[])[0]||{}).qty || "1");
			const vItemharga	= parseFloat(((items_arr||[])[0]||{}).harga_terapi || "0");
			const vItemdiskon	= parseFloat(((items_arr||[])[0]||{}).diskon_terapi || "0");
			const vItemnilai	= vItemqty * (vItemharga - vItemdiskon);

			vItemcount++;
			vPaymentnama		= (vKeteranganArr[0]||{}).payment_caption || "";
			vPaymentISasuransi	= ((vKeteranganArr[0]||{}).init_asuransi || "TIDAK") === "YA";
			vPaymentnilai		= parseFloat((vKeteranganArr[0]||{}).payment_bayar || "0");

			if(vKeteranganArr.length > 1)
				vPaymentnama += " - Rp"+UFunc.formatAngka(vPaymentnilai);
			vPaymentcount++;

			const vNilaitagihan	= !vPaymentISasuransi 
				? parseFloat(nilai_tagihan ?? "0") - (vISRowadaasuransi ? parseFloat(nilai_asuransi ?? "0") : 0) 
				: vPaymentnilai;
			const vNilaiterbayar= !vPaymentISasuransi ? parseFloat(nilai_terbayar ?? "0") : 0;
			const vNilaisisa 	= !vPaymentISasuransi 
				? parseFloat(nilai_sisa ?? "0") - (vISRowadaasuransi ? parseFloat(nilai_asuransi ?? "0") : 0) 
				: vNilaitagihan;

			vTmpObj	= {
				no : {v:vKeys+1,t:"n",s:{alignment:{vertical:"top",}}},
				tgl_bayar: {v:UFunc.toDate(tgl_bayar),t:"d",s:{alignment:{horizontal:"left",vertical:"top",wrapText:true}}},
				no_nota: {v:(no_nota||"Undfnota"),t:"s",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true}}},
				dokter_caption: {v:(dokter_caption||"Undf Dokter"),t:"s",s:{alignment:{horizontal:"left",vertical:"top",wrapText:true}}},
				pasien_caption: {v:(pasien_caption||"Undf Pasien"),t:"s",s:{alignment:{vertical:"top",wrapText:true}}},
				item_caption: {v:vItemcaption,t:"s",s:{alignment:{vertical:"top",wrapText:true,}}},
				item_qty: { v:vItemqty, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top"}}},
				item_harga: { v:vItemharga, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top"}} },
				item_diskon: { v:vItemdiskon, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top"}} },
				item_nilai: { v:vItemnilai, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top"}}},
				nilai_diskon: { v:parseFloat(nilai_diskon ?? "0"), t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top"}} },
				nilai_omzet: { v:parseFloat(nilai_omzet ?? "0"), t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top"}} },
				nilai_bayar_before: { v:parseFloat(nilai_bayar_before ?? "0"), t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top"}} },
				nilai_tagihan: { v:vNilaitagihan, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top"}} },
				nilai_terbayar: { v:vNilaiterbayar, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top"}} },
				nilai_sisa: { v: vNilaisisa, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top"}}},
				keterangan: {v:vPaymentnama,t:"s",s:{alignment:{vertical:"top",wrapText:true}}},
			} 
			if(!vISadadiskon) delete vTmpObj.nilai_diskon;
			vDatasetsArr.push(vTmpObj);

			let vTagihan 	= "";
			let vTerbayar 	= "";
			if(vItemcount < (items_arr||[]).length)
				(items_arr||[]).filter((_,vKeys)=>vKeys > (vItemcount-1)).map((vItems,vKeys)=>{
					vRowcount++;

					const vItemcaption	= vItems.caption_terapi || "Undf Terapi";
					const vItemqty		= parseInt(vItems.qty) || 1;
					const vItemharga	= parseFloat(vItems.harga_terapi) || 0;
					const vItemdiskon	= parseFloat(vItems.diskon_terapi) || 0;
					const vItemnilai	= vItemqty * (vItemharga - vItemdiskon);

					vPaymentnama	= "";
					vTagihan 		= "";
					vTerbayar 		= "";
					if(vPaymentcount < vKeteranganArr.length) {
						vPaymentnama	= (vKeteranganArr[vKeys+1]||{}).payment_caption || "";
						vPaymentnilai	= parseFloat((vKeteranganArr[vKeys+1]||{}).payment_bayar ?? "0");
						vPaymentISasuransi	= ((vKeteranganArr[vKeys+1]||{}).init_asuransi || "TIDAK") === "YA";

						vPaymentnama += " - Rp"+UFunc.formatAngka(vPaymentnilai);

						if(vPaymentISasuransi) {
							vTagihan 	= { v:vPaymentnilai, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top",}} };
							vTerbayar 	= { v:0,t:"n",s:{alignment:{vertical:"top",}} };
						}
						vPaymentcount++;
					}

					vTmpObj	= {
						no : "",
						tgl_bayar: "",
						no_nota: "",
						dokter_caption: "",
						pasien_caption: "",
						item_caption: {v:vItemcaption,t:"s",s:{alignment:{vertical:"top",wrapText:true,}}},
						item_qty: { v:vItemqty, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top",}} },
						item_harga: { v:vItemharga, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top",}} },
						item_diskon: { v:vItemdiskon, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top",}} },
						item_nilai: { v:vItemnilai, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top",}} },
						nilai_diskon: "",
						nilai_omzet: "",
						nilai_bayar_before: "",
						nilai_tagihan: vTagihan,
						nilai_terbayar: vTerbayar,
						nilai_sisa: vTagihan,
						keterangan: {v:vPaymentnama,t:"s",s:{alignment:{vertical:"top",wrapText:true}}},
					} 
					if(!vISadadiskon) delete vTmpObj.nilai_diskon;
					/*if(vISpaymentselected) delete vTmpObj.payment_caption;//-*/

					vItemcount++;
					vDatasetsArr.push(vTmpObj);
				});

			if(vPaymentcount < vKeteranganArr.length) 
				vKeteranganArr.filter((_,vKeys)=>vKeys > (vPaymentcount-1)).map((vItems,vKeys)=>{
					vRowcount++;

					vTagihan 		= "";
					vTerbayar 		= "";
					vPaymentnama	= vItems.payment_caption || "";
					vPaymentnilai	= parseFloat(vItems.payment_bayar ?? "0");
					vPaymentISasuransi	= (vItems.init_asuransi || "TIDAK") === "YA";
					
					vPaymentnama += " - Rp"+UFunc.formatAngka(vPaymentnilai);
					if(vPaymentISasuransi) {
						vTagihan 	= { v:vPaymentnilai, t:"n", s:{numFmt: "#,##0",alignment:{vertical:"top",}} };
						vTerbayar 	= { v:0,t:"n",s:{alignment:{vertical:"top",}} };
					}
					vPaymentcount++;

					vTmpObj	= {
						no : "",
						tgl_bayar: "",
						no_nota: "",
						dokter_caption: "",
						pasien_caption: "",
						item_caption: "",
						item_qty: "",
						item_harga: "",
						item_diskon: "",
						item_nilai: "",
						nilai_diskon: "",
						nilai_omzet: "",
						nilai_bayar_before: "",
						nilai_tagihan: vTagihan,
						nilai_terbayar: vTerbayar,
						nilai_sisa: vTagihan,
						keterangan: {v:vPaymentnama,t:"s",s:{alignment:{vertical:"top",wrapText:true}}},
					} 
					if(!vISadadiskon) delete vTmpObj.nilai_diskon;

					vDatasetsArr.push(vTmpObj);
				});
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"right"},font:{bold:true} }},
			tgl_bayar: "",
			no_nota: "",
			dokter_caption: "",
			pasien_caption: "",
			item_caption: "",
			item_qty: "",
			item_harga: "",
			item_diskon: "",
			item_nilai: "",
			nilai_diskon: "",
			nilai_omzet: { v:parseFloat(uDatasumArr.nilai_omzet)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_bayar_before: "",
			nilai_tagihan: { v:parseFloat(uDatasumArr.nilai_tagihan)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_terbayar: { v:parseFloat(uDatasumArr.nilai_terbayar)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_sisa: { v:parseFloat(uDatasumArr.nilai_sisa)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			keterangan: "",
		};
		if(!vISadadiskon) delete vTmpObj.nilai_diskon;

		//console.log(vRowcount+" => "+JSON.stringify(vTmpObj));
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:43}]
		const wscols	= [
			{wpx:40},
			{wpx:80},
			{wpx:80},
			{wpx:140},
			{wpx:175},
			{wpx:275},
			{wpx:50},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:100},
			{wpx:100},
			{wpx:100},
			{wpx:100},
			{wpx:100},
			{wpx:275},
		];
		if(!vISadadiskon) wscols.splice(10,1);
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:11}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile = 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPOMZET_"+
			vTglawallabel+"_"+vTglakhirlabel+
		"";
		const vSheetlabel = vTglawallabel;

		const ws 		= XLSX.utils.json_to_sheet(vDatasetsArr);
		
		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode "+UFunc.TglAngka(uFilterObj.tgl_awal)+" s.d. "+UFunc.TglAngka(uFilterObj.tgl_akhir)+
			(uDatacabangArr.length > 1 ? "\r\nCabang: "+vCabangtext : "" )+
			(parseInt(uFilterObj.payment_id ?? "-1") >= 0 ? "\r\nPayment: "+vPaymentcaption : "")+
			(parseInt(uFilterObj.asuransi_id ?? "0") > 0 ? "\r\nAsuransi: "+vAsuransicaption : "")+
			//"\r\n"+(vISadadiskon?"vISadadiskon":"vNO_adadiskon")+
		"";

		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center",vertical:"top"},font:{bold:true}}}, 
			{v:"Tanggal",s:{alignment:{horizontal:"left",vertical:"top"},font:{bold:true}}}, 
			{v:"No.Nota",s:{alignment:{horizontal:"center",vertical:"top"},font:{bold:true}}}, 
			{v:"Dokter",s:{alignment:{horizontal:"left",vertical:"top"},font:{bold:true}}}, 
			{v:"Pasien",s:{alignment:{horizontal:"left",vertical:"top"},font:{bold:true}}}, 
			{v:"Item",s:{alignment:{horizontal:"left",vertical:"top"},font:{bold:true}}}, 
			{v:"Kuantitas",s:{alignment:{horizontal:"center",vertical:"top"},font:{bold:true}}}, 
			{v:"Harga",s:{alignment:{horizontal:"center",vertical:"top"},font:{bold:true}}}, 
			{v:"Diskon",s:{alignment:{horizontal:"center",vertical:"top"},font:{bold:true}}}, 
			{v:"Subtotal\r\nTransaksi",t:"s",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true,},font:{bold:true}}}, 
			{v:"Total\r\nDiskon",t:"s",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true,},font:{bold:true}}}, 
			{v:"N.Transaksi\r\n(Rp)",t:"s",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true,},font:{bold:true}}}, 
			{v:"Bayar Sblmnya\r\n(Rp)",t:"s",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true,},font:{bold:true}}}, 
			{v:"N.Tagihan\r\n(Rp)",t:"s",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true,},font:{bold:true}}}, 
			{v:"N.Pembayaran\r\n(Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true,},font:{bold:true}}}, 
			{v:"Sisa Tagihan\r\n(Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true,},font:{bold:true}}}, 
			{v:"Metode Bayar",s:{alignment:{horizontal:"left",vertical:"top",wrapText:true,},font:{bold:true}}}, 
		];
		if(!vISadadiskon) vHeaderArr.splice(10,1);

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	//--END CONTENT--/

	//--REST_API--/
	const apiLoadawal = async() => {
		setHtml500msg();
	    setDataasuransiArr([]);
	    setDatapaymentArr([]);

		const vDATAS    = JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vHeaderObj	= {
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST", mode: "cors",
			cache: "default",
		}

		let vElbtnview	= document.getElementById("btnFilter");
		vElbtnview && (vElbtnview.disabled = true);
		setLoading(true);
		try {
			setSessionaktif(false);

			const [output_asuransi,output_payment] = await Promise.all([
				(async () => {
					const vURLs	= pjson.homepage+"api2/api_lapomzet/ld_masterasuransi";
					const vDATAS= JSON.stringify({
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response ASURANSI was not ok.');
					return response.json();
				})(),

				(async () => {
					const vURLs	= pjson.homepage+"api2/api_rekapnota/ld_payment";
					const vDATAS= JSON.stringify({
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response PAYMENT was not ok.');
					return response.json();
				})(),
			]);

			setSessionaktif(true);
			//--output_asuransi--/
			if(output_asuransi.tampil) {
				setDataasuransiArr(JSON.parse(output_asuransi.dataasuransi||"[]"))
			} else if(output_asuransi.info) {
				setHtml500msg(output_asuransi.info); return;
			} else if(output_asuransi.errors) {
				console.log("(Lapomzet - apiLoadawal) output_asuransi.errors : "+output_asuransi.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_asuransi.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_asuransi.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END output_asuransi--/

			//--output_payment--/
			if(output_payment.tampil) {
				setDatapaymentArr(JSON.parse(output_payment.datapayment||"[]"))
			} else if(output_payment.info) {
				setHtml500msg(output_payment.info); return;
			} else if(output_payment.errors) {
				console.log("(Lapomzet - apiLoaddata) output_payment.errors : "+output_payment.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_payment.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_payment.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END output_payment--/
		} catch (errorObj) {
			console.log("(Lapomzet - apiLoaddata) catch-error : "+errorObj.message);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		} finally {
			vElbtnview && (vElbtnview.disabled = false);
			setLoading(false);
		}
	}
	const _apiLoadawal_ = () => {//--TIDAK_DIPAKAI--/
		setHtml500msg();
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Lapomzet - apiLoadawal) LEWaT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
		},2500); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_lapomzet/ld_masterasuransi";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				setDataasuransiArr(JSON.parse(output_string.dataasuransi||"[]"));
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapomzet - apiLoadawal) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg(vMsg);
			} else if(output_string.expired) {
				setDlgformshow(false); setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Lapomzet - apiLoadawal) catch-error : "+error);
			//showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoaddata = (_PAGE) => {
		_PAGE		= parseInt(_PAGE) || 0;

		let vAsuransicaption = "";
		if(parseInt(uFormdataObj.asuransi_id ?? "0") > 0) {
			if(parseInt(uFormdataObj.asuransi_id) > 0) {
				const vIdx = UFunc.getObjectIndeks(uDataasuransiArr,uFormdataObj.asuransi_id);
				vAsuransicaption = (uDataasuransiArr[vIdx]||{}).nama_asuransi || "Undf Payment";
			} 

			setFormdataObj({...uFormdataObj,asuransi_caption : vAsuransicaption});
		}

		uElBtnsimpan && (uElBtnsimpan.disabled = true)
		setLoading(true);
		const vTmpFilterObj 		= {...uFormdataObj,
			asuransi_caption: vAsuransicaption,
			init_change: undefined,
		};

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			uElBtnsimpan && (uElBtnsimpan.disabled = false)
			clearTimeout(vTimeout)
		},2500); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_filterlist : JSON.stringify(vTmpFilterObj),
			//send_pg	: _PAGE <= 0 ? 1 : _PAGE,
			//send_maxdata	: uMaxData,
			send_firstload	: uFirstload,//vHandelview,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_lapomzet/ld_laporan";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			uElBtnsimpan && (uElBtnsimpan.disabled = false)
			setLoading(false);
			setSessionaktif(true);
			if(output_string.tampil) {
				setFilterObj(vTmpFilterObj);
				const vLoadArr	= JSON.parse(output_string.dataobject||"[]");

				/*//--LOAD_PER_PAGE--/
				vLoadArr.map(vItems=>vItems.pg = parseInt(_PAGE)||1);
				setDatamainArr([...vDatamainArr,...vLoadArr]);
				setJmlData(parseInt(output_string.totaldata||uJmlData));
				//--END LOAD_PER_PAGE--*/

				//--LOAD_ALL_VIEW_PER_PAGE--/
				setDatamainArr(vLoadArr);
				//setJmlData(vLoadArr.length);
				//--END LOAD_ALL_VIEW_PER_PAGE--*/

				setFirstload("TIDAK");

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
				
				hdlToggleDlgform();
				setDataloaded(true);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapomzet - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			uElBtnsimpan && (uElBtnsimpan.disabled = false)
			setLoading(false);
			console.log("(Lapomzet - apiLoaddata) catch-error : "+error);
			console.error("(Lapomzet - apiLoaddata) error.message : "+error.message);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END REST_API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});
		
		apiLoadawal();

		return () => {
			setDlgformshow(false);
			uDispatch({type: "set", gInitHeaderAction: {}});
			setDatamainArr([]);setDataasuransiArr([]);
	    	setDatapaymentArr([]);
			setDataloaded(false)
		}
	},[])
	React.useEffect(()=>{ initJmldata() },[uElJmlData])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setPageActive(uPageActive<=0?1:uPageActive);

		initJmldata()
	},[uJmlData])
	React.useEffect(()=>{ 
		if(uDatamainArr.length <= 0)
			{ setDatadefaultArr([]); return }

		uDatamainArr.map(vItems => vItems.nilai_jumlah = 
				parseFloat(vItems.nilai_asuransi ?? "0") + 
				parseFloat(vItems.nilai_terbayar ?? "0")
			);

		//setDatadefaultArr([{init_change:"1"},...uDatamainArr]) 
		setDatadefaultArr([...(JSON.parse(JSON.stringify(uDatamainArr)))]) 
	},[uDatamainArr])
	React.useEffect(()=>{
		setJmlData(uDatamainArr.length)
		if(uDatamainArr.length <= 0)
			{ setDatasumObj({}); return }

		const vSumbruto	= uDatamainArr.reduce(
			(vStores,vItems) => vStores = vStores + parseFloat(vItems.nilai_bruto ?? "0"), 0);
		const vSumomzet	= uDatamainArr.reduce(
			(vStores,vItems) => vStores = vStores + parseFloat(vItems.nilai_omzet ?? "0"), 0);
		const vSumasuransi	= uDatamainArr.reduce(
			(vStores,vItems) => vStores = vStores + parseFloat(vItems.nilai_asuransi ?? "0"), 0);
		const vSumtagian	= uDatamainArr.reduce(
			(vStores,vItems) => vStores = vStores + parseFloat(vItems.nilai_tagihan ?? "0"), 0);
		const vSumbayar	= uDatamainArr.reduce(
			(vStores,vItems) => vStores = vStores + parseFloat(vItems.nilai_terbayar ?? "0"), 0);
		const vSumsisa	= uDatamainArr.reduce(
			(vStores,vItems) => vStores = vStores + parseFloat(vItems.nilai_sisa ?? "0"), 0);

		setDatasumObj({
			nilai_bruto: vSumbruto,
			nilai_omzet: vSumomzet,
			nilai_tagihan: vSumtagian,
			nilai_asuransi: vSumasuransi,
			nilai_terbayar: vSumbayar,
			nilai_jumlah: vSumasuransi + vSumbayar,
			nilai_sisa: vSumsisa,
		});
	},[uDatamainArr,uDatamainArr.length])
	React.useEffect(()=>{
		/*//--LOAD_PER_PAGE--/
		if(uFirstload==="YA") return;

		setIDselect(0);
		setRowselect(-1);
		const vDatapageArr = uDatamainArr.filter(vItems=>parseInt(vItems.pg||0)===parseInt(uPageActive||1));
		if(vDatapageArr.length > 0) { 
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}

		apiLoaddata(uPageActive);
		//--END LOAD_PER_PAGE--*/

		//--LOAD_ALL_VIEW_PER_PAGE--/
		setIDselect(0);
		setRowselect(-1);
		//--END LOAD_ALL_VIEW_PER_PAGE--/
	},[uPageActive])//-->Unselect_ROW
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) return;
		
		const vCabangID = localStorage.getItem("lastcabangid") || 
			(uDatacabangArr[0].id || "0");

		const vTanggalnowDT			= new Date();
		const vTanggalLastmonthDT 	= new Date(vTanggalnowDT.getTime());
		vTanggalLastmonthDT.setDate(1);
		vTanggalLastmonthDT.setMonth(vTanggalLastmonthDT.getMonth() - 1);
		
		const vTglawalDT 			= new Date(vTanggalLastmonthDT.getFullYear(), vTanggalLastmonthDT.getMonth(), 26);
		const vTglakhirDT 			= new Date(vTanggalnowDT.getFullYear(), vTanggalnowDT.getMonth(), 25);
		
		const vTglawal 	= UFunc.DbDate(vTglawalDT);
		const vTglakhir = UFunc.DbDate(vTglakhirDT);

		setFormdataObj({
			cabang_id: uFilterObj.cabang_id || vCabangID,
			tgl_awal: uFilterObj.tgl_awal || vTglawal,
			tgl_akhir: uFilterObj.tgl_akhir || vTglakhir,
			payment_id: uFilterObj.payment_id || "-1",
			asuransi_id: uFilterObj.asuransi_id || "0",
			init_change: 1
		});

		setHeaderDlgform("Pilih Filter Laporan")
		setDlgformshow(true)
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelReset) return;

		uHeaderActionObj.isHeaderreset = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) { apiLoadawal(); }
		else { setDataloaded(false); }
	},[uHandelReset])
	React.useEffect(()=>{
		if(!uIsDataloaded)
			{ initResettampilan(); return; }

		//--SET_TITLE--/
		let vTitelmain	= "Periode ";
		vTitelmain += "<b>"+UFunc.TglAngka(uFormdataObj.tgl_awal)+"</b>";
		if(uFormdataObj.tgl_awal !== uFormdataObj.tgl_akhir)
			vTitelmain += " s.d. <b>"+UFunc.TglAngka(uFormdataObj.tgl_akhir)+"</b>";
		
		/*if(uFormdataObj.jenis === "TANGGAL") {
		} else {
			vTitelmain += "BULAN <b>"+cBulanPanjang[parseInt(uFormdataObj.bln)-1]+" "+uFormdataObj.thn+"</b>";
		}//-*/

		const vCabangIdx= UFunc.getObjectIndeks(uDatacabangArr,uFormdataObj.cabang_id);
		let vTitelsub	= uDatacabangArr.length > 1 ? (uDatacabangArr[vCabangIdx]||{}).cabang_nama || "Undf Cabang" : "";

		if(parseInt(uFormdataObj.payment_id ?? "-1") >= 0) {
			const vPaymentidx	= UFunc.getObjectIndeks(uDatapaymentArr,uFormdataObj.payment_id);
			vTitelsub	+= (vTitelsub!==""?" &middot; ":"")+"<b>"+((uDatapaymentArr[vPaymentidx]||{}).nama_payment || "TUNAI")+"</b>";
		}
		if(parseInt(uFormdataObj.asuransi_id ?? "0") > 0) {
			vTitelsub	+= (vTitelsub!==""?" &middot; ":"")+"<b>"+(uFormdataObj.asuransi_caption || "Asuransi")+"</b>";
		}

		//vTitelsub = "&middot; "+vTitelsub+" &middot;";
		setCaptionObj({title:vTitelmain,title_sub:vTitelsub});
		//--END SET_TITLE--/
	},[uIsDataloaded])
	React.useEffect(()=>{
		//console.log("(Lapomzet - [uIsDlgformshow]) uFilterObj => "+JSON.stringify(uFilterObj));
		if(!uIsDlgformshow) 
			{ setFormdataObj({}); return }

		//console.log("(Lapomzet - [uIsDlgformshow]) uFormdataObj => "+JSON.stringify(uFormdataObj));
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			const vButton = document.getElementById("btnDialogSimpan");
			vButton && (vButton.innerHTML = "Tampilkan");
			setElBtnsimpan(vButton);

			let vElfocus = document.getElementById("inpcabangid");
			if(!vElfocus)
				vElfocus = document.getElementById("inptglawal");

			if(!isMobile)
				vElfocus && vElfocus.focus();
		},350)
	},[uIsDlgformshow])
	React.useEffect(()=>{
		if(uDatamainArr.length <= 0) return;
		if(uPageActive > 1) setPageActive(1);
		else 
			{ setRowselect(-1); setIDselect(0); }

		if(JSON.stringify(uSortedObj||{}) === "{}") { return; }

		let vSortedArr;
		const vNamasort = (uSortedObj.nama||"").toLowerCase();
		if(uSortedObj.jenis === "ASCENDING") {
			vSortedArr	= uDatamainArr.sort((a, b) => a[vNamasort] - b[vNamasort]);
		}else if(uSortedObj.jenis === "DESCENDING") {
			vSortedArr	= uDatamainArr.sort((a, b) => b[vNamasort] - a[vNamasort]);
		} else {
			vSortedArr	= uDatadefaultArr.slice(1);//.splice(0,1);
		}
		setDatamainArr([...vSortedArr]);
		//setEfekview(!uEfekview);
	},[uSortedObj,
	uSortedObj.nama,
	uSortedObj.jenis,
	])
	
	//console.log("(Lapomzet) uActiveroute => "+(uActiveroute));
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return; }
	if(uHtml500msg) return (
		<CCard className="classbgcard">
		<CCardHeader className="fw-bolder">Page 500</CCardHeader>
		<CCardBody className="mx-md-5 p-md-5">
		<div className="fst-italic">
		{UFunc.renderHTML(uHtml500msg)}
		</div>
		</CCardBody>
		</CCard>
	)//>

	return (
		<>
		{(!uIsDataloaded) ? (
		<CCard className="classbgcard">
		<CCardHeader className="fw-bolder">Pilih Filter Laporan</CCardHeader>
		<CCardBody className="mx-lg-5 p-lg-5">
		<div className="mx-md-5 p-md-5 fst-italic classpetunjuk">
		*) Silahkan Pilih Filter, untuk menentukan Parameter Laporan yang akan Ditampilkan. Kemudian Tekan SIMPAN. Untuk Mencetak Silahkan KLIK Ikon Cetak..
		</div>
		</CCardBody>
		</CCard>
		) : (
		<>
		<CCard className="classbgcard">
		<CCardHeader className="d-flex justify-content-between">
		<div>
			<div>{UFunc.renderHTML(uCaptionObj.title)}</div>
			<small>
				<span className="classfontsmaller text-primary">
				{UFunc.renderHTML(uCaptionObj.title_sub)}
				</span>
			</small>
		</div>

		<div className="text-end" style={{minWidth:80}}>
			<CDropdown className="d-md-none">
				<CDropdownToggle caret={false} size="sm"
					className="p-0" color="transparent">
					<CIcon icon="cilChevronBottom" className="classikonbox mx-1" height={25}/>
				</CDropdownToggle>
				<CDropdownMenu>
					<CDropdownItem onClick={()=>hdlKlikCetak()}>
						<CIcon className="classikoncetak ms-0 me-2 align-middle" height={25}/>
						Cetak Laporan
					</CDropdownItem>
					<CDropdownItem onClick={()=>hdlKlikExcel()}>
						<CIcon className="classikonexcel ms-0 me-2 align-middle" height={25}/>
						Export-2-Excel
					</CDropdownItem>
				</CDropdownMenu>
			</CDropdown>

			<span className="d-none d-md-inline">
				<CTooltip content="--CETAK..">
				<CLink 
					className="classikontabel classikoncetak classcursorpointer"
					onClick={()=>hdlKlikCetak()}/>
				</CTooltip>
				<span className="mx-1">&middot;</span>
				<CTooltip content="--Export-2-Excel..">
				<CLink 
					className="classikontabel classikonexcel classcursorpointer"
					onClick={()=>hdlKlikExcel()}/>
				</CTooltip>
			</span>

			<small className="me-1">&middot;</small>
			<small><span className="text-muted classfontsmaller">{UFunc.formatAngka(uTimeelapse)}ms</span></small>
		</div>
		</CCardHeader>
		
		<CCardBody className="px-0">{contentLaporan()}</CCardBody>

		{(uJmlData > uMaxData) && (
			<CCardFooter>
			<MyPagination 
				activePage={uPageActive}
				pages={uJmlHal}
				onActivePageChange={(i)=>setPageActive(i)}
				align="start"/>
			</CCardFooter>
		)}
		</CCard>
		</>
		)}

		<MyDialogform
			options={{centered:true}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={uIsDlgformshow} 
			dialogHeader={uHeaderDlgform}
			toggle={hdlToggleDlgform}
			renderContent={contentDlgform()}/>

		<iframe id="ifmcontentstoprint" className="d-none"/>
		<div className="d-none">
			{(uSystemsettingObj.url_image_nota||"")!=="" && (
				<img src={uSystemsettingObj.url_image_nota} height="100"/>
			)}
		</div>
		</>
	)//>
}	

export default Lapomzet